import styled from "styled-components";

import { ContactUsStyledProps as Props } from "./ContactUs.types";
import { CONSTANTS } from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const ContactUsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: var(--sizes-navbar-height);
  background-color: var(--palette-gray-s0-l97);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;

  .ContactUs {
    &__header {
      grid-column: fullBleed;
    }

    &__main {
      grid-column: content;
      flex: 1;
      display: flex;
      flex-direction: column;

      &__header {
        @media (max-width: ${tablet}px) {
          display: none;
        }
      }
    }

    &__profile-navigation {
      width: 29.6rem;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__layout {
      display: flex;
      padding-top: 2.4rem;
      flex: 1;

      @media (max-width: ${tablet}px) {
        padding-top: 0.8rem;
      }
    }

    &__content {
      flex: 1;
      padding: 0rem 2rem;
      margin-left: 2.4rem;
      display: flex;
      flex-direction: column;

      @media (max-width: ${tablet}px) {
        margin-left: 0;
        width: 100%;
        padding: 1.4rem 0.4rem;
      }

      &__backSVG {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 4rem;
        width: 4rem;
        background-color: var(--palette-white);
        border-radius: 1.2rem;
        cursor: pointer;
      }

      &__title {
        padding-top: 1.2rem;
        padding-bottom: 2rem;
        font-weight: 500;
        font-size: 2.8rem;
        line-height: 3.6rem;
        color: var(--palette-black-s0-l10);
      }

      &__subTitle {
        font-weight: 600;
        font-size: 1.8rem;
        line-height: 2rem;
        padding-bottom: 2.4rem;
      }

      &__body {
        display: flex;
        flex-direction: column;
        gap: 2rem;
      }

      &__mainError {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &__subTitleError {
        font-size: 1.6rem;
        line-height: 2rem;
        padding-bottom: 2.4rem;
      }
    }

    &__contact-method {
      color: var(--palette-black-s0-l10);
      font-weight: 600;
      font-size: 1.6rem;

      &:not(:last-child) {
        margin-bottom: 1.6rem;
      }

      a {
        font-weight: 500;
        color: var(--palette-black-s0-l10);
        text-decoration: none;
      }
    }

    &__footer {
      grid-column: fullBleed;
      margin-top: 3.2rem;
    }
  }
`;

export default ContactUsStyled;
